import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { useContent } from "@/lib/content";

export default function Footer() {
  const content = useContent();
  const phone = content?.contact?.phone || "0456 492 849";
  const email = content?.contact?.email || "lucas@heritageconstructions.com.au";

  return (
    <footer className="relative overflow-hidden bg-charcoal text-ivory" data-testid="site-footer">
      <div className="wrap pb-10 pt-20 sm:pt-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo size="h-24" onDark />
            <p className="mt-6 max-w-sm font-serif text-2xl leading-snug text-ivory/90">
              Built with purpose. <span className="italic text-gold-light">Finished with precision.</span>
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ivory/55">
              Established in the Yarra Valley, Heritage Constructions undertakes residential carpentry
              and construction projects across the surrounding areas, including Maroondah and selected
              Melbourne suburbs.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow !text-gold-light">Explore</p>
            <ul className="mt-5 space-y-3">
              {[
                ["Home", "/"],
                ["Services", "/services"],
                ["Our Work", "/our-work"],
                ["About", "/about"],
                ["Request a Quote", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="group inline-flex items-center gap-1.5 text-sm text-ivory/70 transition-colors hover:text-ivory">
                    {label}
                    <ArrowUpRight size={13} className="opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow !text-gold-light">Talk to Lucas</p>
            <div className="mt-5 space-y-4">
              <a href={`tel:${phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-3 text-lg text-ivory/85 transition-colors hover:text-gold-light">
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-ivory/20"><Phone size={14} /></span>
                {phone}
              </a>
              <a href={`mailto:${email}`} data-testid="footer-email-link" className="flex items-center gap-3 break-all text-sm text-ivory/85 transition-colors hover:text-gold-light">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-ivory/20"><Mail size={14} /></span>
                {email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <p className="outline-word whitespace-nowrap font-serif text-[18vw] leading-none tracking-tight md:text-[11rem]">
            HERITAGE
          </p>
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-ivory/10 pt-6 text-xs text-ivory/40 sm:flex-row sm:items-center">
          <span className="h-px flex-1" aria-hidden="true" />
          <Link to="/admin" className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/30 transition-colors hover:text-gold-light" data-testid="footer-admin-link">
            Owner Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
